import { updateItemQuantity } from './helpers';

window.addEventListener('load', () => {
  const countButtonsWrapper = document.querySelectorAll(
    '.product-card .count-button',
  );

  let timeout;

  if (countButtonsWrapper) {
    [].forEach.call(countButtonsWrapper, (wrapper) => {
      const countInput = wrapper.querySelector('.count-input');
      const buttonPlus = wrapper.querySelector('.plus');
      const buttonMinus = wrapper.querySelector('.minus');
      const productId = wrapper.dataset.id;
      const menuType = wrapper.dataset.type;

      const body = {
        id: productId,
      };

      if (buttonPlus) {
        let countPlus = 0;
        buttonPlus.addEventListener('click', () => {
          clearTimeout(timeout);

          countPlus++;
          countInput.value = parseInt(countInput.value, 10) + 1;

          if (parseInt(countInput.value, 10) > 1) {
            buttonMinus.classList.remove('disabled');
          }

          if (parseInt(countInput.value, 10) === 99) {
            buttonPlus.classList.add('disabled');
          }

          body.quantity = countPlus;

          timeout = setTimeout(() => {
            updateItemQuantity({
              body,
              method: 'POST',
              menuType,
              isUpdatePromosList: true,
            });
            countPlus = 0;
          }, 300);
        });
      }

      if (buttonMinus) {
        let countMinus = 0;
        buttonMinus.addEventListener('click', () => {
          clearTimeout(timeout);

          if (parseInt(countInput.value, 10) > 1) {
            countMinus--;
            countInput.value = parseInt(countInput.value, 10) - 1;

            body.quantity = countMinus;

            timeout = setTimeout(() => {
              updateItemQuantity({
                body,
                method: 'POST',
                menuType,
                isUpdatePromosList: true,
              });
              countMinus = 0;
            }, 300);
          }

          if (parseInt(countInput.value, 10) === 1) {
            buttonMinus.classList.add('disabled');
          }

          if (
            parseInt(countInput.value, 10) < 99 &&
            buttonPlus.classList.contains('disabled')
          ) {
            buttonPlus.classList.remove('disabled');
          }
        });
      }
    });
  }
});
